@if (lorenzFormControl) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper"
			 [ngClass]="{'radio-row': lorenzFormControl.getDirection() === 'row'}">

			@for (radioOption of lorenzFormControl.getOptions(); track $index) {

				<label class="radio-option"
					 [ngClass]="{
					 	'highlighted': lorenzFormControl.isHighlighted(),
					 	'missing-required': lorenzFormControl.isMissingRequiredValue()
					 }">

					<input type="radio"
						   [formControlName]="controlName"

						   [attr.name]="controlFullKey"

						   [value]="radioOption.value"

						   class="dot"
						   [ngClass]="{
								'readonly': lorenzFormControl.isBlocked(),
								'no-label': !lorenzFormControl.hasLabel()
						   }"

						   (click)="readonlyHandler($event)"
					>

					<span class="label"
						  [ngClass]="{
							  'faulty': lorenzFormControl.isFaulty(),
							  'missing-required': lorenzFormControl.isMissingRequiredValue(),
							  'highlighted': lorenzFormControl.isHighlighted()
						  }"
						  [innerHTML]="radioOption.label | translate">
					</span>

				</label>

			}

			<lib-form-validity-dot [control]="lorenzFormControl" />

		</div>

	</div>

	@if (showErrorMessages) {
		<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
	}

}
